export enum MatrixServiceId {
    ANONYM, // Vill du vara anonym?
    CONTAINER_1, // Container 1 Kontaktuppgifter
    JOBB, // Var jobbar du
    FORNAMN, // Ditt förnamn
    EFTERNAMN, // Ditt efternamn
    TELEFONNUMMER, // Telefonnummer till dig
    OVRIG_KONTAKT, // Övriga kontaktuppgifter
    ANMALA_PERSON, // Vem vill du anmäla?
    PERSON_FORNAMN, // Personens förnamn
    PERSON_EFTERNAMN, // Personens efternamn
    PERSON_PERSON_NR, // Personens personnummer
    PERSON_KONTAKT, // Kontaktuppgifter till personen
    VET_PERSONNUMMER, // Har du personnummer till personen?
    ANMALA_FORETAG, // Vilket företag vill du anmäla?
    FORETAG_NAMN, // Företagets namn
    FORETAG_ORG_NUMMER, // Organisationsnummer
    FORETAG_FORETRADARE, // Namn på bolagets företrädare
    FORETAG_UPPGIFTER, // Övriga uppgifter
    CONTAINER_2, // Container 2 Observationer
    SITUATION_PRIVATPERSON, // Vilken situation gäller din misstanke? (Privatperson)
    ARBETE_ERSATTNING, // Personen arbetar samtidigt som ersättning betalas ut från FK
    ENSAMSTAENDE, // Personen är sammanboende men får ersättning som ensamstående
    BOR_UTOMLANDS, // Personen får ersättning men har flyttat utomlands
    FEL_ASSISTANS_ERSATTNING, // Personen får assistansersättning felaktigt
    ANNAT_PRIVAT, // Annat (Privatperson)
    ANNAT_FORETAG, // Annat (Företag)
    SITUATION_FORETAG, // Vilken situation gäller din misstanke? (Företag)
    TANDVARDSSTOD, // Statligt tandvårdsstöd
    ASSISTANSERSATTNING, // Assistansersättning
    PERSON_MEDVETEN, // Tror du personen är medveten...
    FORETAG_MEDVETET, // Tror du att företaget är medvetet...
    BILAGOR, // Ladda upp bilagor
    CONTAINER_3, // Container 3 Kvittens
    SPARA_SKRIV_UT, // Spara och skriv ut
    VILKEN_SITUATION, // Vilken situation gäller din misstanke? (fråga)
    UNDERRATTELSESKYLDIGHET, // Lämnas uppgifterna med stöd av lagen om underrättelseskyldighet (fråga)
    TYP_AV_ERSATTNING, // Typ av ersättning (oberoende av situation)
    ANNAT_PRIVAT_FRAGOR, // Inmatningsfält kopplade till "Annat privat"
}
